import React, { useState } from "react";

export const useCategorieMultiSelect = (initialValue: string[]) => {
  const [selectedCategorie, setSelected] = useState<string[]>(initialValue);

  const onChangeCategorie = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const index = selectedCategorie.indexOf(value);
    if (index > -1) {
      setSelected([...selectedCategorie.slice(0, index), ...selectedCategorie.slice(index + 1)]);
    } else {
      setSelected([...selectedCategorie, ...[value]]);
    }
  };

  const isSelectedCategorie = (value: string) => {
    return selectedCategorie.includes(value);
  };

  return { selectedCategorie, isSelectedCategorie, onChangeCategorie };
};

export const useOrderSingleSelect = (initialValue: string[]) => {
  const [selectedOrder, setSelected] = useState<string[]>(initialValue);

  const onChangeOrder = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const index = selectedOrder.indexOf(value);
    if (index === -1) {
      setSelected([value]);
    }
  };

  const isSelectedOrder = (value: string) => {
    return selectedOrder.includes(value);
  };

  return { selectedOrder, isSelectedOrder, onChangeOrder };
};

export const useStatusMultiSelect = (initialValue: string[]) => {
  const [selectedStatus, setSelectedStatus] = useState<string[]>(initialValue);

  const onChangeStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const index = selectedStatus.indexOf(value);
    if (index > -1) {
      setSelectedStatus([...selectedStatus.slice(0, index), ...selectedStatus.slice(index + 1)]);
    } else {
      setSelectedStatus([...selectedStatus, ...[value]]);
    }
  };

  const isSelectedStatus = (value: string) => {
    return selectedStatus.includes(value);
  };

  return { selectedStatus, isSelectedStatus, onChangeStatus };
};